<template>
    <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="Payout" force-render>
            <a-table rowKey="id" :data-source="capt_xu_payouts" :columns="payout_columns">
                <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                    style="padding: 8px">
                    <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                        :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                        @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                        @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                        Search
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                        Reset
                    </a-button>
                </div>
                <a-icon slot="filterIcon" slot-scope="filtered" type="search"
                    :style="{ color: filtered ? '#108ee9' : undefined }" />
                <template slot="customRender" slot-scope="text, record, index, column">
                    <span v-if="searchText && searchedColumn === column.dataIndex">
                        <template v-for="(fragment, i) in text
                            .toString()
                            .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                            <mark v-if="fragment.toLowerCase() === searchText.toLowerCase()" :key="i"
                                class="highlight">{{ fragment }}</mark>
                            <template v-else>{{ fragment }}</template>
                        </template>
                    </span>
                    <template v-else>
                        {{ text }}
                    </template>
                </template>
                <template slot="upload" slot-scope="text, record">
                    <div v-for="(a, a_pos) in record.attachment" :key="a.uid">
                        <a :href="a.url">
                            {{ a.filename }}
                        </a>
                    </div>
                </template>
                <template slot="is_paid" slot-scope="text, record">
                    <span v-if="record.is_paid" style="font-weight: bold; color: green;">Y</span>
                    <span v-else style="font-weight: bold; color: red;">N</span>
                </template>
                <template slot="action" slot-scope="text, record">
                    <a href="#" onclick="document.getElementById('upload_payout_file').click(); return false;">Upload
                        Bank Slip</a>
                    <input type="file" id="upload_payout_file" style="display: none;"
                        @change="e => { upload_file(e, record) }" />
                    <a-popconfirm title="Are you sure Reset to Unpaid?" ok-text="Yes" cancel-text="No" @confirm="() => {
                        vue_instance.$http.post(vue_instance.$store.state.base_url + '/capt_xu_payouts/u', {
                            ...record,
                            is_paid: false
                        }).then((r) => {
                            record.is_paid = false;
                        })
                    }">"
                        <a-button type="link" size="small">Reset to Unpaid</a-button>
                    </a-popconfirm>

                </template>
            </a-table>
        </a-tab-pane>
        <a-tab-pane key="2" tab="Income" force-render>
            <a-table rowKey="id" :data-source="capt_xu_incomes" :columns="income_columns">
                <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                    style="padding: 8px">
                    <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                        :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                        @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                        @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                        Search
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                        Reset
                    </a-button>
                </div>
                <a-icon slot="filterIcon" slot-scope="filtered" type="search"
                    :style="{ color: filtered ? '#108ee9' : undefined }" />
                <template slot="customRender" slot-scope="text, record, index, column">
                    <span v-if="searchText && searchedColumn === column.dataIndex">
                        <template v-for="(fragment, i) in text
                            .toString()
                            .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                            <mark v-if="fragment.toLowerCase() === searchText.toLowerCase()" :key="i"
                                class="highlight">{{ fragment }}</mark>
                            <template v-else>{{ fragment }}</template>
                        </template>
                    </span>
                    <template v-else>
                        {{ text }}
                    </template>
                </template>
                <template slot="upload" slot-scope="text, record">
                    <div v-for="(a, a_pos) in record.attachment" :key="a.uid">
                        <a :href="a.url">
                            {{ a.filename }}
                        </a>
                    </div>
                </template>
                <template slot="is_received" slot-scope="text, record">
                    <span v-if="record.is_received" style="font-weight: bold; color: green;">Y</span>
                    <span v-else style="font-weight: bold; color: red;">N</span>
                </template>
            </a-table>
        </a-tab-pane>
    </a-tabs>
</template>


<script>
import userinfo from "../../utils/userinfo.js";
export default {
    name: "capt_xu_vsl_mgt_cost",
    data() {
        return {
            vue_instance: this,
            capt_xu_vessels: [],
            capt_xu_payouts: [],
            capt_xu_incomes: [],
            headers: {
                access_token: userinfo.get().access_token,
            },

            userinfo: userinfo.get(),

            searchText: '',
            searchInput: null,
            searchedColumn: '',

            payout_columns: [
                {
                    title: 'ID',
                    dataIndex: 'id',
                    key: 'id',
                    align: 'center',
                },
                {
                    title: 'Vessel Name',
                    dataIndex: 'vessel_name',
                    key: 'vessel_name',
                    align: 'center',
                    scopedSlots: {
                        filterDropdown: 'filterDropdown',
                        filterIcon: 'filterIcon',
                        customRender: 'customRender',
                    },
                    onFilter: (value, record) =>
                        record.vessel_name
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                    onFilterDropdownVisibleChange: visible => {
                        if (visible) {
                            setTimeout(() => {
                                this.searchInput.focus();
                            }, 0);
                        }
                    },
                },
                {
                    title: 'Date',
                    dataIndex: 'date',
                    key: 'date',
                    align: 'center',
                },
                {
                    title: 'Item Name',
                    dataIndex: 'item_name',
                    key: 'item_name',
                    align: 'center',
                },
                {
                    title: 'Beneficiary',
                    dataIndex: 'beneficiary',
                    key: 'beneficiary',
                    align: 'center',
                },
                {
                    title: 'Amount',
                    dataIndex: 'amount',
                    key: 'amount',
                    align: 'center',
                },
                {
                    title: 'Remarks',
                    dataIndex: 'remarks',
                    key: 'remarks',
                    align: 'center',
                },
                {
                    title: 'Is Paid',
                    dataIndex: 'is_paid',
                    key: 'is_paid',
                    align: 'center',
                    scopedSlots: { customRender: "is_paid" },
                },
                {
                    title: 'Upload',
                    align: 'center',
                    scopedSlots: { customRender: "upload" },
                },
                {
                    title: 'Actions',
                    dataIndex: 'actions',
                    key: 'actions',
                    align: 'center',
                    scopedSlots: { customRender: "action" },
                }
            ],
            income_columns: [
                {
                    title: 'ID',
                    dataIndex: 'id',
                    key: 'id',
                    align: 'center',
                },
                {
                    title: 'Vessel Name',
                    dataIndex: 'vessel_name',
                    key: 'vessel_name',
                    align: 'center',
                    scopedSlots: {
                        filterDropdown: 'filterDropdown',
                        filterIcon: 'filterIcon',
                        customRender: 'customRender',
                    },
                    onFilter: (value, record) =>
                        record.vessel_name
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                    onFilterDropdownVisibleChange: visible => {
                        if (visible) {
                            setTimeout(() => {
                                this.searchInput.focus();
                            }, 0);
                        }
                    },
                },
                {
                    title: 'Date',
                    dataIndex: 'date',
                    key: 'date',
                    align: 'center',
                },
                {
                    title: 'Item Name',
                    dataIndex: 'item_name',
                    key: 'item_name',
                    align: 'center',
                },
                {
                    title: 'MESSRS',
                    dataIndex: 'messrs',
                    key: 'messrs',
                    align: 'center',
                },
                {
                    title: 'Amount',
                    dataIndex: 'amount',
                    key: 'amount',
                    align: 'center',
                },
                {
                    title: 'Remarks',
                    dataIndex: 'remarks',
                    key: 'remarks',
                    align: 'center',
                },
                {
                    title: 'Is Received',
                    dataIndex: 'is_received',
                    key: 'is_received',
                    align: 'center',
                    scopedSlots: { customRender: "is_received" },
                },
                {
                    title: 'Upload',
                    align: 'center',
                    scopedSlots: { customRender: "upload" },
                },
            ],

        };
    },
    methods: {
        handleSearch(selectedKeys, confirm, dataIndex) {
            confirm();
            this.searchText = selectedKeys[0];
            this.searchedColumn = dataIndex;
        },
        handleReset(clearFilters) {
            clearFilters();
            this.searchText = '';
        },
        upload_file(e, record) {
            const file = e.target.files[0];
            const formData = new FormData();
            formData.append("file", file);
            formData.append("related_id", record.id);
            this.$http
                .post(this.$store.state.base_url + "/upload", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        access_token: this.userinfo.access_token,
                    },
                })
                .then((res) => {
                    if (res.data.status == 1) {
                        if (!record.hasOwnProperty("attachment")) {
                            this.$set(record, "attachment", []);
                        }
                        for (var i = 0; i < res.data.data.length; i++) {
                            var tmp = {};
                            tmp.name = res.data.data[i].filename;
                            tmp.filename = res.data.data[i].filename;
                            tmp.uid = res.data.data[i].path;
                            tmp.path = res.data.data[i].path;
                            tmp.url = this.$store.state.site_url + res.data.data[i].path;
                            tmp.status = "done";
                            record.attachment.push(tmp);
                        }
                        record.is_paid = true;
                        this.$http.post(this.$store.state.base_url + "/capt_xu_payouts/u", { ...record });
                    }
                });
        },


    },

    mounted() {

        this.$http.post(this.$store.state.base_url + "/capt_xu_vessels/r", {}).then((res) => {
            this.capt_xu_vessels = res.data.data;
            this.$http.post(this.$store.state.base_url + "/capt_xu_payouts/r", {}).then((res) => {
                this.capt_xu_payouts = res.data.data;
                this.capt_xu_payouts.forEach((payout) => {
                    let vessel = this.capt_xu_vessels.find(v => v.id === payout.capt_xu_vsl_id);
                    if (vessel) {
                        payout.vessel_name = vessel.vessel_name;
                    } else {
                        payout.vessel_name = 'Unknown';
                    }
                });

            })
            this.$http.post(this.$store.state.base_url + "/capt_xu_incomes/r", {}).then((res) => {
                this.capt_xu_incomes = res.data.data;
                this.capt_xu_incomes.forEach((income) => {
                    let vessel = this.capt_xu_vessels.find(v => v.id === income.capt_xu_vsl_id);
                    if (vessel) {
                        income.vessel_name = vessel.vessel_name;
                    } else {
                        income.vessel_name = 'Unknown';
                    }
                });
            })
        })








    },
    watch: {

    },
};

</script>